export const notifyType = {
    success: 1,
    warning: 2,
    error: 3
}